/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/jsx-no-literals */

'use es6';

import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { getEmailEditConfigurationUrl } from 'conversations-external-deep-links/urls';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getFromName, getId, getFromEmail, getOriginalSenderName, getOriginalSenderEmail, getForwardedEmailContext, getConnectedAccountContext } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  inboxId: PropTypes.number.isRequired,
  message: RecordPropType('ContextUpdateMessage').isRequired
};
const ForwardedEmailContextUpdate = ({
  inboxId,
  message
}) => {
  const forwardedEmailContext = getForwardedEmailContext(message);
  const from = getFromName(forwardedEmailContext) || getFromEmail(forwardedEmailContext);
  const originalSender = getOriginalSenderName(forwardedEmailContext) || getOriginalSenderEmail(forwardedEmailContext);
  const connectedAccountContext = getConnectedAccountContext(message);
  const emailId = getId(connectedAccountContext);
  if (forwardedEmailContext) {
    const connectedAccountLink = /*#__PURE__*/_jsx(UILink, {
      href: getEmailEditConfigurationUrl({
        inboxId,
        emailId
      }),
      external: true,
      use: "blue",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-thread-view.threadHistory.context-update-message.forwardedEmail.tooltip.tooltipLinkName"
      })
    });
    const tooltipMessage = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.forwardedEmail.tooltip.tooltipMessage",
      options: {
        inboxConfigurationLink: connectedAccountLink
      }
    });
    const forwardedEmailTooltip = /*#__PURE__*/_jsxs(UIHelpIcon, {
      title: tooltipMessage,
      children: [/*#__PURE__*/_jsx("b", {
        style: {
          color: '#0091ae'
        },
        children: originalSender
      }), "."]
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.forwardedEmail.forwardedEmailMessage",
      options: {
        originalSender,
        from,
        tooltip: forwardedEmailTooltip
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage"
  }, 'chatflow-source-message');
};
ForwardedEmailContextUpdate.propTypes = propTypes;
export default ForwardedEmailContextUpdate;